import { render, staticRenderFns } from "./shareDialog.vue?vue&type=template&id=23930787&scoped=true&"
import script from "./shareDialog.vue?vue&type=script&lang=js&"
export * from "./shareDialog.vue?vue&type=script&lang=js&"
import style0 from "./shareDialog.vue?vue&type=style&index=0&id=23930787&prod&lang=less&scoped=true&"
import style1 from "./shareDialog.vue?vue&type=style&index=1&id=23930787&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23930787",
  null
  
)

export default component.exports